import * as THREE from "three";
import { TOOTH_GUM_TYPE } from "../constant/toothConstant";

export const getIPREndPosition = (
  firstTargetMat,
  secondTargetMat,
  centerPosition,
  toothGumType
) => {
  const worldMatrixInverse = new THREE.Matrix4();
  worldMatrixInverse.copy(firstTargetMat);
  const localZAxis = new THREE.Vector3(0, 0, 1).applyMatrix4(
    worldMatrixInverse
  );
  localZAxis.setY(centerPosition.y);

  const worldMatrixInverse2 = new THREE.Matrix4();
  worldMatrixInverse2.copy(secondTargetMat);
  const localZAxis2 = new THREE.Vector3(0, 0, 1).applyMatrix4(
    worldMatrixInverse2
  );
  localZAxis2.setY(centerPosition.y);

  const averageVec = new THREE.Vector3();
  averageVec.addVectors(localZAxis, localZAxis2).multiplyScalar(0.5);
  averageVec.normalize();

  let handler_center = centerPosition.clone();
  let y = 1;

  if (toothGumType === TOOTH_GUM_TYPE.LOWER) {
    y = -1;
  }

  handler_center.add(new THREE.Vector3(0, y, 0).multiplyScalar(10));

  handler_center = handler_center.add(averageVec.multiplyScalar(15));

  return {
    x: handler_center.x,
    y: handler_center.y,
    z: handler_center.z,
  };
};

export const getIPRStartPosition = (centerPosition) => {
  return {
    x: centerPosition.x,
    y: centerPosition.y,
    z: centerPosition.z,
  };
};

export const checkIPRVisible = (startPosition, endPosition, cameraPosition, toothGumType) => {
  const startVector = new THREE.Vector3(startPosition.x, startPosition.y, startPosition.z);
  const endVector = new THREE.Vector3(endPosition.x, endPosition.y, endPosition.z);

  const vec = new THREE.Vector3().subVectors(endVector, startVector)


  /**
   * @description    The coordinate systems here are all scene coordinate systems
   *
   * */

      // The vec is projected onto the horizontal plane
  const planeNormal = new THREE.Vector3(0, 1, 0);
  const vecProjection = new THREE.Vector3();
  vecProjection.copy(planeNormal).projectOnVector(vec);
  const vecResult = new THREE.Vector3();
  vecResult.subVectors(vec, vecProjection);

  // Project the vector of the camera position to the origin (0,0,0) onto the horizontal plane
  let cameraVec;

  cameraVec = new THREE.Vector3(cameraPosition.x, cameraPosition.y, cameraPosition.z)

  let cameraVecY = 5

  if (toothGumType === TOOTH_GUM_TYPE.LOWER) {
    cameraVecY = -5
  }

  cameraVec.setY(cameraVecY)


  // Calculate the Angle between two vectors.
  // Since the Angle between the IPR in the middle of the model and the camera is 59.5 degrees, 59.5 needs to be subtracted for zeroing
  const dotProduct = vecResult.dot(cameraVec);
  const magnitudeProduct = vecResult.length() * cameraVec.length();
  const angle = Math.acos(dotProduct / magnitudeProduct);
  const angleInDegrees = THREE.MathUtils.radToDeg(angle);


  if (angleInDegrees - 60 <= 20) {
      return true;
  } else {
      return false;
  }
};
